module.exports = "https://cdn2-fs.clearscore.com/flux/images/1ddca48aadc04693c0483808a060be1e.jpg";